function initRelatedSwipers() {
  if (typeof Swiper === 'undefined') {
    console.error("Swiper is not loaded!");
    return;
  }

  window.relatedSwipers = window.relatedSwipers || [];
  window.relatedSwipers.forEach(sw => sw.destroy(true, true));
  window.relatedSwipers = [];

  document.querySelectorAll('.related-swiper').forEach(el => {
    const wrapper = el.querySelector('.swiper-wrapper');
    if (!wrapper) {
      // Retry čez 300ms, če wrapper še ni v DOM-u (po ajax reload)
      setTimeout(initRelatedSwipers, 300);
      return;
    }

    const swiper = new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 12,
      freeMode: false,
      grabCursor: true,
      speed: 400,
      preloadImages: false,
      lazy: { loadPrevNext: true },
      keyboard: { enabled: true, onlyInViewport: true },
      mousewheel: { forceToAxis: true, sensitivity: 0.7 },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next') || undefined,
        prevEl: el.querySelector('.swiper-button-prev') || undefined,
        disabledClass: 'swiper-button-disabled',
      },
      breakpoints: {
        0:    { slidesPerView: 1.2, spaceBetween: 8, centeredSlides: true },
        480:  { slidesPerView: 1.5, spaceBetween: 12, centeredSlides: false },
        700:  { slidesPerView: 2.5, spaceBetween: 14 },
        900:  { slidesPerView: 3.2, spaceBetween: 20 },
        1200: { slidesPerView: 3.5, spaceBetween: 24 }
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      on: {
        init: function () {
          setTimeout(() => this.update(), 150);
        }
      }
    });
    window.relatedSwipers.push(swiper);
  });
}

// OG listenerji
document.addEventListener("DOMContentLoaded", initRelatedSwipers);
document.addEventListener("shopify:section:load", initRelatedSwipers);
// Dodaj AJAX/VARIANT/EVERY event
document.addEventListener("shopify:cart:change", initRelatedSwipers);
document.addEventListener("shopify:product:variant:change", initRelatedSwipers);
document.addEventListener("shopify:section:select", initRelatedSwipers);
document.addEventListener("shopify:section:deselect", initRelatedSwipers);
document.addEventListener("shopify:block:select", initRelatedSwipers);
document.addEventListener("shopify:block:deselect", initRelatedSwipers);
document.addEventListener("product:variant:change", initRelatedSwipers);
